<template>
  <b-modal
    ref="summaryModal"
    :title="modalTitle"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
    @hidden="notifyParentAboutClose"
  >
    <b-alert class="px-2" show variant="success">
      <span>Sent successfully: </span>
      <strong>{{ sentRecipients.length }}</strong>
    </b-alert>

    <b-alert class="px-2" show variant="danger">
      <span>Failed to send: </span>
      <strong>{{ failedRecipients.length }}</strong>
    </b-alert>

    <div v-if="sentRecipients.length" class="mt-4">
      <h6 class="font-weight-bold mb-2">Sent mails</h6>
      <div class="summary-list">
        <div
          v-for="item in sentRecipients"
          :key="`sent-${item.proposal_id}-${item.address}`"
          class="summary-item text-success"
        >
          <span class="mr-2"><base-material-design-icon icon="check"/></span>
          <span>{{ item.address }}</span>
        </div>
      </div>
    </div>

    <div v-if="failedRecipients.length" class="mt-4">
      <h6 class="font-weight-bold mb-2">Failed mails</h6>
      <div class="summary-list">
        <div
          v-for="item in failedRecipients"
          :key="`failed-${item.proposal_id}-${item.address}`"
          class="summary-item custom-text-danger"
        >
          <span class="mr-2"><base-material-design-icon icon="close"/></span>
          <span>{{ item.address }}</span>
        </div>
      </div>
    </div>

    <div class="text-left mt-4">
      <b-button variant="info" @click="close">
        Close
      </b-button>
    </div>
  </b-modal>
</template>

<script>
  import BaseMaterialDesignIcon from '@/components/base-components/base-icons/BaseMaterialDesignIcon';

  export default {
    name: 'MailSendingSummaryModal',
    props: {
      sentRecipients: {
        type: Array,
        required: true,
      },
      failedRecipients: {
        type: Array,
        required: true,
      },
    },
    components: { BaseMaterialDesignIcon },
    computed: {
      modalTitle() {
        return `Mail sending summary (${this.sentRecipients.length} sent / ${this.failedRecipients.length} failed)`;
      },
    },
    methods: {
      show() {
        this.$refs.summaryModal.show();
      },
      hide() {
        this.$refs.summaryModal.hide();
      },
      close() {
        this.$refs.summaryModal.hide();
      },
      notifyParentAboutClose() {
        this.$emit('close-parent');
      },
    },
  };
</script>

<style scoped>
  .summary-list {
    max-height: 260px;
    overflow-y: auto;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 10px;
  }

  .summary-item {
    display: flex;
    align-items: center;
    padding: 4px 0;
    word-break: break-all;
  }
</style>
